<template>
  <div class="course-schedule-manager">
    <div class="top">
      <div class="radio-group">
        <el-radio-group
          class="school-level-radio"
          v-model="schoolLevel"
          @change="changeSchoolLevel"
        >
          <el-radio-button label="elementary-school">國小</el-radio-button>
          <el-radio-button label="junior-high-school">國中</el-radio-button>
          <el-radio-button label="high-school">高中</el-radio-button>
        </el-radio-group>
        <el-radio-group
          class="location-radio"
          v-model="location"
          @change="changeLocation"
        >
          <el-radio-button label="nantun">南屯校</el-radio-button>
          <el-radio-button label="west-first">西區校 國⼩部</el-radio-button>
          <el-radio-button label="west-second"
            >西區校 國中部/高中部</el-radio-button
          >
          <el-radio-button label="xitun">西屯校</el-radio-button>
        </el-radio-group>
      </div>
      <el-button type="success" @click="createCourseSchedule"
        >新增課程表</el-button
      >
    </div>
    <el-table
      :data="courseScheduleData.list"
      border
      stripe
      empty-text="沒有資料"
      style="width: 100%"
    >
      <el-table-column prop="level" label="層級" width="100">
        <template slot-scope="{ row }">
          <div>{{ levelName(row.level) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="location" label="校區" width="100">
        <template slot-scope="{ row }">
          <div>{{ locationName(row.location) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="grade" label="年級" width="100">
        <template slot-scope="{ row }">
          <div>{{ gradeText(row.grade) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="subjects" label="科目" width="100">
        <template slot-scope="{ row }">
          <div v-for="subject in row.subjects" :key="subject">
            {{ subjectName(subject) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="課程名稱" width="250">
      </el-table-column>
      <el-table-column prop="class_time" label="課程時間" width="180">
        <template slot-scope="{ row }">
          <div v-for="(time, index) in row.class_time" :key="index">
            {{ time }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="class_time" label="狀態" width="140">
        <template slot-scope="{ row }">
          <span>{{ row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column label="修改" width="100">
        <template slot-scope="{ row }">
          <div class="center">
            <el-button type="warning" @click="editCourse(row)">修改</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="刪除" width="100">
        <template slot-scope="{ row }">
          <div class="center">
            <el-button type="danger" @click="remove(row.id)">刪除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="size"
      :total="courseScheduleData.total"
      :current-page.sync="currentPage"
      @current-change="pageChange"
    >
    </el-pagination>
    <CourseScheduleEditor
      :courseScheduleEditorVisible.sync="courseScheduleEditorVisible"
      :courseScheduleForm="courseScheduleForm"
      :isCreate="isCreate"
      @saveCourseSchedule="saveCourseSchedule"
    ></CourseScheduleEditor>
  </div>
</template>

<script>
import CourseScheduleEditor from "@/components/management/CourseScheduleEditor";
import Api from "@/api/MaganmentApi";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  data() {
    return {
      courseScheduleEditorVisible: false,
      schoolLevel: "elementary-school",
      location: "",
      size: 20,
      currentPage: 1,
      isCreate: false,
      courseScheduleForm: {
        level: "",
        location: "",
        grade: "",
        subjects: [
          {
            value: "",
            id: Date.now()
          }
        ],
        description: "",
        class_time: [
          {
            value: "",
            id: Date.now() + 1
          }
        ],
        status: ""
      },
      courseScheduleData: {
        list: [],
        total: 0
      }
    };
  },
  computed: {},
  methods: {
    replaceQuery() {
      let newQuery = {
        schoolLevel: this.schoolLevel,
        location: this.location,
        page: this.currentPage
      };
      this.$router.replace({ query: newQuery });
    },
    changeSchoolLevel() {
      this.replaceQuery();
      this.search();
    },
    pageChange() {
      this.replaceQuery();
      this.search();
    },
    changeLocation() {
      this.replaceQuery();
      this.search();
    },
    levelName(val) {
      switch (val) {
        case "elementary-school":
          return "國小";
        case "junior-high-school":
          return "國中";
        case "high-school":
          return "高中";
      }
    },
    locationName(val) {
      switch (val) {
        case "nantun":
          return "南屯校";
        case "west-first":
          return "西區校  國⼩部";
        case "west-second":
          return "西區校  國中部/高中部";
        case "xitun":
          return "西屯校";
      }
    },
    subjectName(val) {
      switch (val) {
        case "chinese":
          return "國文";
        case "math":
          return "數學";
        case "english":
          return "英文";
        case "natural":
          return "自然";
        case "society":
          return "社會";
        case "physical":
          return "物理";
        case "chemistry":
          return "化學";
        case "biology":
          return "生物";
        case "history":
          return "歷史";
        case "geography":
          return "地理";
        case "citizen":
          return "公民";
        case "all":
          return "全科";
      }
    },
    gradeText(val) {
      switch (val) {
        case 1:
          return "升國一";
        case 2:
          return "升高一";
        case 3:
          return "三年級";
        case 4:
          return "四年級";
        case 5:
          return "五年級";
        case 6:
          return "六年級";
        case 7:
          return "國一";
        case 8:
          return "國二";
        case 9:
          return "國三";
        case 10:
          return "高一";
        case 11:
          return "高二";
        case 12:
          return "高三";
        case 1.1:
          return "⼀年級";
        case 1.2:
          return "⼆年級";
      }
    },
    editCourse(data) {
      let tmpData = _.cloneDeep(data);
      let tmpSubjects = [];
      let i = 0;
      for (let subject of data.subjects) {
        tmpSubjects.push({
          value: subject,
          key: Date.now() + i
        });
        i++;
      }
      tmpData.subjects = _.cloneDeep(tmpSubjects);
      let tmpClassTime = [];
      for (let time of data.class_time) {
        tmpClassTime.push({
          value: time,
          key: Date.now() + i
        });
        i++;
      }
      tmpData.class_time = _.cloneDeep(tmpClassTime);
      this.isCreate = false;
      this.courseScheduleForm = _.cloneDeep(tmpData);
      this.courseScheduleEditorVisible = true;
    },
    remove(id) {
      Swal.fire({
        title: "確定刪除？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "確定"
      }).then(async result => {
        if (result.value) {
          try {
            await Api.removeCourseSchedule(id);
            _.remove(this.courseScheduleData.list, course => {
              return course.id == id;
            });
            this.$set(
              this.courseScheduleData.list,
              this.courseScheduleData.list
            );
            this.$message({
              message: "刪除成功",
              type: "success"
            });
          } catch (e) {
            Swal.fire({
              title: "Error!",
              text: "發生錯誤，請檢查網路或聯絡管理人員",
              icon: "error"
            });
          }
        }
      });
    },
    createCourseSchedule() {
      this.isCreate = true;
      (this.courseScheduleForm = {
        level: "",
        location: "",
        grade: "",
        subjects: [
          {
            value: "",
            id: Date.now()
          }
        ],
        description: "",
        class_time: [
          {
            value: "",
            id: Date.now() + 1
          }
        ],
        status: ""
      }),
        (this.courseScheduleEditorVisible = true);
    },
    async saveCourseSchedule(courseScheduleForm) {
      let courseScheduleData = _.cloneDeep(courseScheduleForm);
      let subjectTempList = [];
      for (let subject of courseScheduleData.subjects) {
        subjectTempList.push(subject.value);
      }
      courseScheduleData.subjects = subjectTempList;
      let timeTempList = [];
      for (let time of courseScheduleData.class_time) {
        timeTempList.push(time.value);
      }
      courseScheduleData.class_time = timeTempList;
      try {
        if (this.isCreate) {
          await Api.createCourseSchedule(courseScheduleData);
          this.init();
          this.courseScheduleEditorVisible = false;
          this.$message({
            message: "新增成功",
            type: "success"
          });
        } else {
          await Api.updateCourseSchedule(courseScheduleData);
          this.init();
          this.courseScheduleEditorVisible = false;
          this.$message({
            message: "修改成功",
            type: "success"
          });
        }
      } catch (e) {
        Swal.fire({
          title: "Error!",
          text: "發生錯誤，請檢查網路或聯絡管理人員",
          icon: "error"
        });
      }
    },
    async search() {
      const query = {
        level: this.schoolLevel,
        location: this.location,
        page: this.currentPage,
        size: this.size
      };
      const res = await Api.getCourseList(query);
      this.courseScheduleData = res.data;
    },
    init() {
      this.isCreate = false;
      this.courseScheduleForm = {
        level: "",
        location: "",
        grade: "",
        subjects: [
          {
            value: "",
            id: Date.now()
          }
        ],
        description: "",
        class_time: [
          {
            value: "",
            id: Date.now() + 1
          }
        ],
        status: ""
      };
      this.currentPage = this.$route.query.page
        ? parseInt(this.$route.query.page)
        : 1;
      this.schoolLevel = this.$route.query.schoolLevel
        ? this.$route.query.schoolLevel
        : "elementary-school";
      this.location = this.$route.query.location
        ? this.$route.query.location
        : "";
      this.search();
    }
  },
  created() {
    this.init();
  },
  mounted() {},
  components: {
    CourseScheduleEditor
  }
};
</script>

<style lang="scss" scoped>
.course-schedule-manager {
  .top {
    margin-bottom: 15px;
    display: flex;
    align-items: center;

    .el-radio-group {
      margin-right: 50px;
    }

    .school-level-radio {
      margin-bottom: 10px;
    }
  }
}
</style>
